module.exports = "/_next/static/images/kawashima-02ca5c4fde8a5f3417f18b148b825351.jpg";